import React, { useEffect, useState } from 'react';
import {
  Container,
  Form,
  Row,
  Col,
  Button,
  Alert,
} from '@themesberg/react-bootstrap';
import { get, post } from '../../../services/back.service';
import ListTables from '../../shared/tables';

function FormInfoBodywork({ id, vehicleclass }) {
  const [selectparts, setSelectParts] = useState('');
  const [selectstate, setSelectState] = useState('');
  const [rejected_bodywork, setRejectedBodywork] = useState('');
  const [parts, setParts] = useState([]);
  const [states, setStates] = useState([]);
  const [infoBodywork, setInfoBodywork] = useState([]);
  const [msgButton, setMsgButton] =useState('Guardar Informacion')
  const [alert, setAlert] = useState({ show: false, message: '', type: '' });

  const saveForm = (e) => {
    e.preventDefault()
    infoBodywork.push({
      id_part: selectparts,
      id_state: selectstate,
    });
    setSelectParts('');
    setSelectState('');
    setInfoBodywork(infoBodywork);
    //generalUpdate('infoBodywork', infoBodywork);
  };

  const deleteItem = (idx) => {
    infoBodywork.splice(idx-1, 1);
    setInfoBodywork([...infoBodywork]);
    //generalUpdate('infoBodywork', infoBodywork);
  };

  const editButton = (row) => {
    return (
      <Button
        title="Modificar Combustible"
        text="Editar"
        variant="outline-primary"
        onClick={()=>deleteItem(row.id)}
      >Eliminar</Button>
    );
  };

  const infoTable =()=>{
    // {type: 'C', id_part: '11', id_state: '1'} 
    let tmpTable =[]
    for (let index = 0; index < infoBodywork.length; index++) {
      const element = infoBodywork[index];
      const currentpart = parts.find((e)=> e.id.toString() === element.id_part.toString())
      const currentstate = states.find((e)=> e.id.toString() === element.id_state.toString())
      if(currentpart && currentstate) tmpTable.push({id: (index+1), pieza:currentpart.name, estado:currentstate.name})
    }
    return(<ListTables 
      data={tmpTable}
      editar={editButton}
      messageWd={'Agrege una parte'}
      />)
  }

  const sendInfo = async (event) => {
    event.preventDefault();
    const body = {
      header: { rejected_bodywork },
      type:'E',  
      data: infoBodywork
    };
    const respo = await post('/peritaje/modifyinspection/parts/'+id, body);
    if(respo.success){
      setAlert({ show: false, message: '', type: '' });
      setMsgButton('Actualizar')
    } else {
      setAlert({ show: true, message: respo.message, type: 'danger' });
    }

  };
  
  useEffect(() => {
    const initForm = async () => {
      const body = {type:'E'};
      const respo = await post('/peritaje/infodetailinspection/parts/'+id, body);
      if(respo.success){
        const {detail, header} = respo.data;
        setInfoBodywork(detail);
        setRejectedBodywork(header.rejected_bodywork)
      }
    };

    const getInfoBodyWork = async () => {
      const respoInfo = await get( `/peritaje/infopartsinspection/${vehicleclass}/E` ,  {});
      if (respoInfo.success) {
        const { piecevehicle, stateapp } = respoInfo.data;
        setParts(piecevehicle);
        setStates(stateapp);
      } else {
        console.log(respoInfo.message);
      }
    };
    getInfoBodyWork();
    initForm();
  }, [vehicleclass, id]);

  return (
    <Container>
      <Row className="mb-1">
        <Col>
          <h1 className="fw-bold">Carrocería</h1>
        </Col>
      </Row>
      <hr style={{ opacity: 0.1 }} />
      <Row>
        <Col xs={12} md={6}>
          <Form onSubmit={saveForm}>
          <Form.Label htmlFor="partecarroceria">Parte Carroceria</Form.Label>
          <Form.Select
            name="selectparts"
            value={selectparts}
            onChange={(e) => setSelectParts(e.target.value)}
            aria-label="Default select example"
            required
          >
            <option value="">Seleccione</option>
            {parts.map((element, i) => {
                const valid = infoBodywork.findIndex((part)=> part.id_part.toString() === element.id.toString() )
                if(valid<0){
                  return (
                    <option key={i} value={element.id}>
                      {element.name}
                    </option>
                  );
                }else{
                  return null;
                }
            })}
          </Form.Select>
          <Form.Label htmlFor="estado">Estado</Form.Label>
          <Form.Select
            name="selectstate"
            value={selectstate}
            onChange={(e) => setSelectState(e.target.value)}
            aria-label="Default select example"
            required
          >
            <option value="">Seleccione</option>
            {states.map((element, i) => {
              return (
                <option key={i} value={element.id}>
                  {element.name}
                </option>
              );
            })}
          </Form.Select>
          <Row className="my-3">
            <Col className="d-flex justify-content-end">
              <Button
                type="submit"
                variant="primary"
              >
                Agregar Parte
              </Button>
            </Col>
          </Row>
          </Form>
        </Col>
        <Col>
        {infoTable()}
        </Col>
      </Row>
      {alert.show && <Alert variant={alert.type} onClose={() => setAlert({ show: false, message: '', type: '' })} dismissible>{alert.message}</Alert>}
      <Row className="my-3">
      <Col>
        <Form.Label htmlFor="estado">RECHAZADO POR CARROCERIA</Form.Label>
            <Form.Select
              name="rejected_bodywork"
              value={rejected_bodywork}
              onChange={(e) => setRejectedBodywork(e.target.value)}
              aria-label="Default select example"
              required
            >
              <option value="NO">NO</option>
              <option value="SI">SI</option>
            </Form.Select>
        </Col>
        <Col className="d-flex justify-content-end">
          <Button type="button" variant="primary" onClick={sendInfo} >
            {msgButton}
          </Button>
        </Col>
      </Row>
    </Container>
  );
}

export default FormInfoBodywork;
